import React from "react";
import { columnHeaderCellType } from "../../../../common/types/search/results";
import clsx from "clsx";

interface SearchResultsHeaderCellProps {
	classes: { [key: string]: string };
	column: columnHeaderCellType;
	columnRenderers: { [key: string]: unknown };
	onSortClick: (columnKey: string, currentSort: string) => void;
}

export function SearchResultsHeaderCell({
	classes,
	column,
	columnRenderers,
	onSortClick,
}: SearchResultsHeaderCellProps) {
	const columnKey = column.get("key");
	const currentSort = column.get("sort");

	const handleSortClick = () => {
		onSortClick(columnKey, currentSort);
	};

	if (columnRenderers[columnKey] === undefined) {
		return (
			<th key={columnKey}>{`No renderer for column '${columnKey}'`}</th>
		);
	} else {
		let ariaSort: "none" | "ascending" | "descending" | "other" = "none";

		if (currentSort === "asc") {
			ariaSort = "ascending";
		} else if (currentSort === "desc") {
			ariaSort = "descending";
		}

		return (
			<th
				key={columnKey}
				aria-sort={ariaSort}
				className={clsx(classes[columnKey])}
			>
				<button
					type="button"
					onClick={handleSortClick}
					className="btn--sort"
				>
					{column.get("label")}
				</button>
			</th>
		);
	}
}
